import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.555 9.62v6.585M12.038 6.47v9.735M16.445 13.104v3.101M12 2.4v1.44M11.827 18.845l2.755 2.755M9.062 21.6l2.756-2.755M16.253 18.807c-2.89.048-5.722.048-8.506 0-3.091 0-5.347-2.208-5.347-5.232V9.11c0-3.034 2.256-5.232 5.347-5.232a251 251 0 0 1 8.506 0c3.091 0 5.347 2.208 5.347 5.232v4.464c0 3.024-2.256 5.232-5.347 5.232",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }